import { memo, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import { ActionModal } from '../../../components/Modal';
import { selectAuth } from '../../auth/auth.slice';
import { useAppSelector } from '../../../app/hooks';
import { useUser } from '../../../components/form/user-form/use-user';
import { emptyUser } from '../../../models/empty-user';
import { validateUser } from '../../../models/validate-user';
import { UserForm } from '../../../components/form/user-form/user-form';

const styles = () => {
  return createStyles({
    root: {},
  });
};

export interface IAddCustomerModalProps extends WithStyles<typeof styles> {
  customStyles?: any;
  open: boolean;
  handleClose?: any;
  handleAddCustomer: (data: any) => void;
  selectCustomer: any;
}

const AddCustomerModal = ({
  open,
  handleClose,
  handleAddCustomer,
  selectCustomer,
}: IAddCustomerModalProps) => {
  const auth = useAppSelector(selectAuth);
  const { updateUser, user, resetState } = useUser({ ...emptyUser });
  const { fieldErrors, hasErrors } = validateUser(user, [
    'role',
    'parentId',
    'status',
  ]);
  const intl = useIntl();

  useEffect(() => {
    handleClose();
    resetState();
  }, [selectCustomer.loading]);

  const onClose = () => {
    handleClose();
    resetState();
  };

  const onClickActionButton = () => {
    if (!hasErrors) {
      const customerData = {
        name: user.profile.name,
        email: user.email,
        contactNumber: user.profile.contactNumber,
        ...(auth.user?.role !== 'subadmin' && { role: user.role }),
      };
      handleAddCustomer(customerData);
    }
  };

  const _userRolesArray = [
    {
      label: intl.formatMessage({
        id: 'customer',
      }),
      value: 'customer',
    },
    {
      label: intl.formatMessage({
        id: 'subadmin',
      }),
      value: 'subadmin',
    },
  ];

  return (
    <ActionModal
      modalTitle={intl.formatMessage({
        id: 'add_customer',
      })}
      modalDescription={intl.formatMessage({
        id: 'make_customers_to_manage_meetings',
      })}
      id="add-customer-modal"
      open={open}
      isSingleButton
      handleClose={onClose}
      actinButtonOnClick={onClickActionButton}
      actinButtonLabel={intl.formatMessage({
        id: 'add_customer',
      })}
      actionButtonDisabled={hasErrors}
    >
      <UserForm
        fields={{
          name: {
            error: fieldErrors.name,
            required: true,
          },
          contactNumber: {
            error: fieldErrors.contactNumber,
            required: true,
          },
          email: {
            error: fieldErrors.email,
            required: true,
          },
          ...(auth.user?.role !== 'subadmin' && {
            role: {
              error: fieldErrors.role,
              required: true,
              options: _userRolesArray,
            },
          }),
          password: {
            error: fieldErrors.password,
            required: true,
          },
        }}
        updateUser={updateUser}
        user={user}
      />
    </ActionModal>
  );
};

export default memo(withStyles(styles)(AddCustomerModal));
